const parseErrorData = (error) => {
    const data =
        error?.response?.body
        || error?.response?.data
        || error?.response?.text

    if (typeof data !== "string") return data

    try {
        return JSON.parse(data)
    } catch {
        return {}
    }
}

const formatErrorDetails = (details) => {
    if (!details || typeof details !== "object") return ""

    return Object.entries(details)
        .flatMap(([field, errors]) => {
            const messages = Array.isArray(errors) ? errors : [errors]
            return messages.map((message) => `${field}: ${message}`)
        })
        .join(" ")
}

export const getApiErrorMessage = (
    error,
    fallback = "Não foi possível realizar a operação."
) => {
    const data = parseErrorData(error)
    const message = data?.Message || fallback
    const details = formatErrorDetails(data?.Details)

    if (details) return `${message} ${details}`

    const statusCode = error?.response?.status ?? error?.status
    const isUnexpectedError =
        statusCode >= 500
        || data?.Code === "erro_interno"

    const headers = error?.response?.headers
    const requestId =
        data?.RequestID
        || headers?.["x-request-id"]
        || headers?.["X-Request-ID"]
        || headers?.get?.("x-request-id")

    return isUnexpectedError && requestId
        ? `${message} Código de referência: ${requestId}`
        : message
}